import banner1Cn from "assets/Desktop/images/banner/banner 1 cn.png";
import banner1Turkey from "assets/Desktop/images/banner/banner 1 turkey.png";
import banner1En from "assets/Desktop/images/banner/banner 1.png";
import banner2Cn from "assets/Desktop/images/banner/banner 2 cn.png";
import banner2Turkey from "assets/Desktop/images/banner/banner 2 turkey.png";
import banner2En from "assets/Desktop/images/banner/banner 2.png";
import { AnnouncementItemType } from "types/announcement";

import {
  AnnouncementFormType,
  AnnouncementResponse,
  BannerType,
  GetBannerResponseType,
} from "./type";

const BANNERS_BY_LANG: Record<string, BannerType[]> = {
  tr: [
    {
      banner_id: "1",
      banner_name: "TK88 Turkey Banner 1",
      web_banner: banner1Turkey,
      mobile_banner: banner1Turkey,
      banner_url: "",
      banner_sequence: "1",
      icon: "",
    },
    {
      banner_id: "2",
      banner_name: "TK88 Turkey Banner 2",
      web_banner: banner2Turkey,
      mobile_banner: banner2Turkey,
      banner_url: "",
      banner_sequence: "2",
      icon: "",
    },
  ],
  zh: [
    {
      banner_id: "1",
      banner_name: "TK88 Chinese Banner 1",
      web_banner: banner1Cn,
      mobile_banner: banner1Cn,
      banner_url: "",
      banner_sequence: "1",
      icon: "",
    },
    {
      banner_id: "2",
      banner_name: "TK88 Chinese Banner 2",
      web_banner: banner2Cn,
      mobile_banner: banner2Cn,
      banner_url: "",
      banner_sequence: "2",
      icon: "",
    },
  ],
  en: [
    {
      banner_id: "1",
      banner_name: "TK88 English Banner 1",
      web_banner: banner1En,
      mobile_banner: banner1En,
      banner_url: "",
      banner_sequence: "1",
      icon: "",
    },
    {
      banner_id: "2",
      banner_name: "TK88 English Banner 2",
      web_banner: banner2En,
      mobile_banner: banner2En,
      banner_url: "",
      banner_sequence: "2",
      icon: "",
    },
  ],
};

const ANNOUNCEMENTS_BY_LANG: Record<
  string,
  Array<{
    id: number;
    title: string;
    content: string;
  }>
> = {
  tr: [
    {
      id: 1,
      title: "TK88'e Hoş Geldiniz",
      content:
        "TK88'e hoş geldiniz. 7/24 otomatik yatırım ve çekim sistemi, piyasadaki en yüksek oranlar!",
    },
    {
      id: 2,
      title: "%100 İlk Yatırım Bonusu",
      content:
        "Kayıt olan ve ilk yatırımını yapan tüm yeni üyelere anında %100 hoş geldin bonusu.",
    },
    {
      id: 3,
      title: "Günlük %1.5'e Varan Kayıp İadesi",
      content:
        "Spor, Canlı Casino ve Slot oyunlarında limitsiz günlük otomatik nakit iade fırsatı.",
    },
  ],
  en: [
    {
      id: 1,
      title: "Welcome to TK88",
      content:
        "Welcome to TK88. Automatic 24/7 deposit and withdrawal system, highest payout rates in the market!",
    },
    {
      id: 2,
      title: "100% First Deposit Bonus",
      content:
        "New members registering and making their first deposit receive an instant 100% welcome bonus.",
    },
    {
      id: 3,
      title: "Daily Cashback Up To 1.5%",
      content:
        "Bet on Sports, Live Casino, and Slots to receive unlimited daily cashback instantly.",
    },
  ],
  zh: [
    {
      id: 1,
      title: "歡迎來到 TK88",
      content:
        "歡迎來到 TK88。全天候 24/7 自動存提款系統，市場最高賠率與極速出款！",
    },
    {
      id: 2,
      title: "100% 首存迎新紅利",
      content:
        "新會員註冊並完成首次存款，即可立即領取 100% 迎新紅利獎勵。",
    },
    {
      id: 3,
      title: "每日返水高達 1.5%",
      content:
        "暢玩體育、真人視訊及電子遊藝，享受每日無上限極速自動返水。",
    },
  ],
  vi: [
    {
      id: 1,
      title: "Chào mừng đến với TK88",
      content:
        "Chào mừng đến với TK88. Hệ thống nạp rút tự động 24/7, tỷ lệ trả thưởng cao nhất thị trường!",
    },
    {
      id: 2,
      title: "Thưởng 100% Nạp Tiền Lần Đầu",
      content:
        "Thành viên mới đăng ký và thực hiện nạp tiền lần đầu nhận ngay 100% tiền thưởng chào mừng.",
    },
    {
      id: 3,
      title: "Hoàn Trả Hàng Ngày Lên Đến 1.5%",
      content:
        "Cược Thể Thao, Live Casino và Slot game nhận ngay hoàn trả tự động không giới hạn mỗi ngày.",
    },
  ],
};

export const AnnouncementApi = {
  getAnnouncement: async (payload: AnnouncementFormType) => {
    const rawLng = localStorage.getItem("i18nLng") || "tr";
    const currentLang = rawLng.startsWith("zh")
      ? "zh"
      : rawLng.startsWith("vi")
        ? "vi"
        : rawLng.startsWith("en")
          ? "en"
          : "tr";

    const announcementList =
      ANNOUNCEMENTS_BY_LANG[currentLang] || ANNOUNCEMENTS_BY_LANG["tr"];

    const mockAnnouncements: AnnouncementItemType[] = announcementList.map(
      (item) => ({
        id: item.id,
        title: item.title,
        content: item.content,
        start: new Date().toISOString(),
        end: new Date(Date.now() + 86400000 * 30).toISOString(),
      })
    );

    return {
      data: {
        status: 0,
        msg: "Success",
        data: mockAnnouncements,
        currentPage: payload?.page || 1,
        pageSize: payload?.size || 10,
        totalCount: mockAnnouncements.length,
        totalPages: 1,
        type: payload?.type,
      } as AnnouncementResponse,
    };
  },
  async getBanner(lang?: string) {
    const rawLng =
      lang ||
      localStorage.getItem("i18nLng") ||
      localStorage.getItem("syslang") ||
      "tr";
    const currentLang = rawLng.startsWith("zh")
      ? "zh"
      : rawLng.startsWith("vi")
        ? "en"
        : rawLng.startsWith("en")
          ? "en"
          : "tr";

    const bannerList = BANNERS_BY_LANG[currentLang] || BANNERS_BY_LANG["tr"];

    return {
      status: 0,
      msg: "Success",
      data: bannerList,
    } as GetBannerResponseType;
  },
};
